<template>
  <div class="form-container" :class="[className]" >
    <div class="form-container__column">
      <p-label :input-id="id.first" :label="label" />
      <div class="form-container__inputs">
        <p-input-prepend v-if="iconName" :disabled="disabled">
          <p-icon :icon-name="iconName"
                  color="white"
                  :border-radius="false" />
        </p-input-prepend>
        <p-form-field :id="id.first"
                      :form-type="FormFieldType.INPUT"
                      :input-type="inputType.first"
                      :name="name.first"
                      class="input--left"
                      :min="min?.first"
                      :max="max?.first"
                      :disable-errors="true"
                      :disabled="disabled">
        </p-form-field>
        <p-form-field :id="id.second"
                      :form-type="FormFieldType.INPUT"
                      :input-type="inputType.second"
                      :name="name.second"
                      class="input--right"
                      :min="min?.second"
                      :max="max?.second"
                      :disable-errors="true"
                      :disabled="disabled">
        </p-form-field>
      </div>
    </div>
    <div v-if="errorMessage" class="form-container__error">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { FormFieldType } from '@pidz/enums';
import { InputTypeHTMLAttribute } from 'vue';
import { PIcon, PInputPrepend, PLabel } from '../../atoms/';
import { PFormField } from '../index';

defineProps<{
  label?: string
  iconName?: string
  errorMessage?: string | boolean
  className?: string
  min?: DoubleFieldType<number | string | undefined, number | string | undefined>
  max?: DoubleFieldType<number | string | undefined, number | string | undefined>
  name: DoubleFieldType<string, string>
  id: DoubleFieldType<string, string>
  inputType: DoubleFieldType<InputTypeHTMLAttribute, InputTypeHTMLAttribute>
  disabled?: boolean
} >();

</script>

<style scoped lang="scss">
.form-container{
  width: 100%;

  &__column{
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__inputs{
    display: flex;
  }

  &__error{
    font-size: 13px;
    color: var(--pidz-red);
    margin-bottom: 0;
    margin-top: 6px;
  }
  &.padding-bottom{
    &--large{
      padding-bottom: 24px;
    }
    &--small{
      padding-bottom: 12px;
    }
  }
}
</style>
